<template>
<order-list :is-order-status="90"></order-list>
</template>

<script>
import OrderList from './components/OrderList'
export default {
  name: 'Closed',
  components: {
    OrderList
  }
}
</script>
